import { render, staticRenderFns } from "./UploadComponent.vue?vue&type=template&id=8b1979c4&scoped=true&"
import script from "./UploadComponent.vue?vue&type=script&lang=js&"
export * from "./UploadComponent.vue?vue&type=script&lang=js&"
import style0 from "./UploadComponent.vue?vue&type=style&index=0&id=8b1979c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b1979c4",
  null
  
)

export default component.exports